import { css } from '@emotion/core';

export default css`
  .gm-style {
    font-family: 'Ciutadella' !important;
  }
`;
